const config = {};
    
// URL serwera
config.baseURL ='https://archiwum.radioolsztyn.pl';
    
// nazwa kontrolera API
config.apiURL = config.baseURL + '/PodcastAPI';
   

export {config};